"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMonthOptions = void 0;
var date_fns_1 = require("date-fns");
exports.getMonthOptions = function (startDate, endDate) {
    var months = [];
    var startMonth = date_fns_1.startOfMonth(startDate);
    var endMonth = date_fns_1.startOfMonth(endDate);
    for (var i = startMonth; date_fns_1.isBefore(i, endMonth) || date_fns_1.isEqual(i, endMonth); i = date_fns_1.addMonths(i, 1)) {
        months.push({
            value: date_fns_1.format(i, 'yyyy-MM-dd'),
            label: date_fns_1.format(i, 'MMM-yyyy'),
        });
    }
    return months;
};
